
import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import OverviewWidget from "./overview/overviewWidget";
import ChangelogWidget from "./changelog/changeLog";
import NotesWidget from "./notes/notesWidget";
import './sideAddressDetails.scss';

const tabData = [
    { label: "Overview", content: <OverviewWidget /> },
    { label: "Notes", content: <NotesWidget /> },
    { label: "Change Log", content: <ChangelogWidget /> }
];

const SideAddressDetails: React.FC = () => {
    return (
        <div className="address-details">
            <Tabs defaultIndex={0}>
                <TabList>
                    {tabData.map((tab, index) => (
                        <Tab key={index}>{tab.label}</Tab>
                    ))}
                </TabList>

                {tabData.map((tab, index) => (
                    <TabPanel key={index}>{tab.content}</TabPanel>
                ))}
            </Tabs>
        </div>
    );
};

export default SideAddressDetails;
